import React, { useState } from 'react';
import { Spin } from 'antd';
import classNames from 'classnames';
import { ClickAppIcon, CloseXIcon, PaymeIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { getPlatform } from 'modules/global';

import { Modal, Visible } from 'components';

import { useBuyCourse } from '../hooks';
import { setPaymentModal } from '../store';

const paymentMethods = [
  { id: 'payme', logo: <PaymeIcon /> },
  { id: 'click', logo: <ClickAppIcon /> }
];

interface IProps {
  price?: number;
  discountPrice?: number;
}

export const PaymentModal = ({ discountPrice, price }: IProps) => {
  const t = useTranslations();
  const { query } = useRouter();
  const dispatch = useAppDispatch();
  const { mutate, isLoading } = useBuyCourse(query?.course as string);
  const phone = useAppSelector(({ user }) => user.phone);
  const open = useAppSelector(({ lesson }) => lesson.paymentModal);
  const [selectedMethod, setSelectedMethod] = useState(paymentMethods[0]);

  const onClose = () => {
    dispatch(setPaymentModal(false));
  };

  const onBuyCourse = () => {
    const replacedPhone = phone?.replace(/\s|-/g, '').replace(/^\+998/, '');

    mutate({
      type: selectedMethod.id,
      platform: getPlatform(),
      phone: replacedPhone
    });
  };

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onClose={onClose}
      width={513}
      closeIcon={false}
      closable={false}
      className="[&_.ant-modal-content]:!rounded-2xl [&_.ant-modal-content]:!p-4"
    >
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold">{t('tolov_usulini_tanlang')}</p>
        <div onClick={onClose} className="cursor-pointer">
          <CloseXIcon />
        </div>
      </div>
      <div className="my-3 rounded-xl bg-gray-50 p-3">
        <p className="text-xs font-medium">{t('kurs_narxi')}:</p>
        <Visible if={!discountPrice && !!price}>
          <span className="font-bold text-green-500">
            {price?.toLocaleString('ru')} {t('sum')}
          </span>
        </Visible>
        <Visible if={!!discountPrice}>
          <div className="space-x-1.5">
            <span className="font-bold text-green-500">
              {discountPrice} {t('sum')}
            </span>
            <del className="text-sm font-medium text-gray-500">
              {price} {t('sum')}
            </del>
          </div>
        </Visible>
      </div>
      <div className="h-35 flex items-center gap-3">
        {paymentMethods?.map(method => (
          <div
            key={method?.id}
            onClick={() => setSelectedMethod(method)}
            className={classNames('flex h-full w-full cursor-pointer items-center justify-center rounded-lg border-2', {
              'border-green-500': selectedMethod?.id === method?.id,
              'border-gray-200': selectedMethod?.id !== method?.id
            })}
          >
            {method?.logo}
          </div>
        ))}
      </div>
      <button
        disabled={isLoading}
        onClick={onBuyCourse}
        className="shadow-gray-md h-10.5 mt-4 w-full cursor-pointer rounded-xl bg-gray-800 font-medium text-white transition-all duration-300 ease-in-out active:translate-y-1 active:shadow-none disabled:cursor-not-allowed disabled:bg-gray-100 disabled:shadow-none"
      >
        <Spin spinning={isLoading}>{t('xarid_qilish')}</Spin>
      </button>
    </Modal>
  );
};
